var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ob1-popin-modal-visual", {
    attrs: {
      id: _vm.id,
      "aria-labelledby": _vm.id,
      "show-close-button": false,
      "additional-classes": "d-webview-none",
    },
    scopedSlots: _vm._u([
      {
        key: "visual",
        fn: function () {
          return [
            _c("div", { staticClass: "ob1-modal-img d-webview-none" }, [
              _c("div", { staticClass: "image-crop" }, [
                _c("img", {
                  attrs: { src: _vm.visual.src, alt: _vm.visual.alt },
                }),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("h4", { domProps: { innerHTML: _vm._s(_vm.title) } }),
            _vm._v(" "),
            _vm.description
              ? _c("ob1-message-alerte", {
                  staticClass: "pt-1",
                  attrs: {
                    type: "info",
                    "is-simple-alerte": false,
                    title: _vm.description,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "ob1-modal-footer-visual" }, [
              _c("div", { staticClass: "row d-flex align-items-center" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "order-2 order-md-1 col-12 col-md-6 pt-2 pt-md-0",
                  },
                  [
                    _c("ob1-liens", {
                      attrs: {
                        text: _vm.withoutDeviceSection.button.label,
                        href: _vm.withoutDeviceSection.button.href,
                        "is-link": true,
                        "data-oevent-category":
                          _vm.withoutDeviceSection.button.tmsDTO.tagZone,
                        "data-oevent-action":
                          _vm.withoutDeviceSection.button.tmsDTO.tagName,
                        "data-oevent-label":
                          _vm.withoutDeviceSection.button.href,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "order-1 order-md-2 col-12 col-md-6 px-0" },
                  [
                    _c("ob1-boutons", {
                      attrs: {
                        label: _vm.withDeviceSection.button.label,
                        "is-primary": true,
                        "is-button": false,
                        href: _vm.withDeviceSection.button.href,
                        "data-oevent-category":
                          _vm.withDeviceSection.button.tmsDTO.tagZone,
                        "data-oevent-action":
                          _vm.withDeviceSection.button.tmsDTO.tagName,
                        "data-oevent-label": _vm.withDeviceSection.button.href,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }